import { render, staticRenderFns } from "./TransplantSurgeryDetails.vue?vue&type=template&id=512169a8"
import script from "./TransplantSurgeryDetails.vue?vue&type=script&lang=js"
export * from "./TransplantSurgeryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports